import { REFERRER_FORM_URL, STORE_FORM_URL } from '../constants'
import styles from './styles.module.scss'

const ApplicationNavigation = (): JSX.Element => (
  <div className={styles.applicationCard}>
    <h3>フォームから受け付けています</h3>
    <p>
      店舗を紹介したい方も、ご自身のお店で応募したい方も、下のボタンからフォームにご入力ください。
    </p>
    <div>
      <a
        href={REFERRER_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.button} ${styles.primaryButton} ${styles.largeButton}`}
      >
        紹介者登録をする
      </a>
      <a
        href={STORE_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={`${styles.button} ${styles.ghostButton} ${styles.largeButton}`}
      >
        店舗登録をする
      </a>
    </div>
    <small>※店舗登録には紹介者登録（紹介コード）が必要となります</small>
  </div>
)

export default ApplicationNavigation
